/**
 * 회원의 -6차 (PtMsix) 보유 grant 목록 모달 ($j.Ui.JBModal.target 결합).
 *
 * 사용법:
 *   $j.Ui.JBModal.target('member-msix-modal', {
 *       target: '$j.F.Admin.Member.Msix',
 *       data:   { mbNo: 123, memName: '홍길동' },
 *       title:  '홍길동 #123 — -6차 이력',
 *       width:  '950px',
 *   });
 *
 * 컬럼: 오더번호 · 작업일 · 발급일 · 차종 · 장비대금 · 일차 · 초기pt · 현재pt · 상태
 * 상태 판정 규칙은 /adm/msix-sim 의 _openMemberDetail 과 동일.
 * 오더번호는 오더 핸들 팝업(/adm/order/handle)으로 연결된다.
 * 9열이라 width 는 900px 이상을 권한다 — 좁으면 셀마다 줄바꿈이 난다.
 */
export default class Msix {
    constructor() { this._dt = null; }
    destroy() {
        if (this._dt) { this._dt.destroy(); this._dt = null; }
    }

    init() {
        this.mbNo = this.data.mbNo;
        $(`#${this.id}`).html('<div style="padding:20px;text-align:center;color:#888">로딩중...</div>');
        this.load();
    }

    load() {
        const self = this;
        $.ajax({
            type: 'get',
            url: `/adm/ajax/member/${self.mbNo}/msix`,
            dataType: 'json',
            success(data) {
                self.state = data;
                self.render();
            },
            error() {
                $(`#${self.id}`).html('<div style="padding:20px;text-align:center;color:var(--adm-kw-red, red)">데이터를 불러오지 못했습니다.</div>');
            },
        });
    }

    render() {
        const list   = this.state.list   || [];
        const member = this.state.member || {};
        const counts = this.state.counts || { total: 0, active: 0 };
        const ptSum  = parseInt(member.msix_pt_sum || 0);
        const total  = parseInt(counts.total  || 0);
        const active = parseInt(counts.active || 0);
        const fmt = (v) => Number(v ?? 0).toLocaleString();

        const trs = list.map(r => {
            const nday  = parseInt(r.nday || 0);
            const used  = parseInt(r.used_ordernum || 0);
            const usedDate = r.used_date;

            let status, cls;
            if (usedDate) {
                if (used > 0)         { status = '수주에 사용';    cls = 'text-muted'; }
                else if (used === -1) { status = '오더취소 회수'; cls = 'text-danger'; }
                else if (used === -2) { status = '<i class="fas fa-heart res-i is-odr"></i> 발주개수 전환'; cls = 'text-muted'; }
                else if (used === -3) { status = '관리자 회수';   cls = 'text-warning'; }
                else                  { status = '사용됨';        cls = 'text-muted'; }
            } else if (nday > 10) {
                status = '만료(11일+)'; cls = 'text-muted';
            } else {
                status = '활성';       cls = 'text-success';
            }

            const initialPt = r.initial_pt != null ? fmt(r.initial_pt) : '—';
            const currentPt = r.current_pt != null ? fmt(r.current_pt) : '—';

            return `<tr>
                <td>${this._orderLink(r.ordernum)}</td>
                <td>${r.work_day || '—'}</td>
                <td>${r.start_date || '—'}</td>
                <td>${this._esc(r.car_type || '')}</td>
                <td class="text-right">${fmt(r.car_price)}</td>
                <td class="text-right">${nday}일차</td>
                <td class="text-right">${initialPt}</td>
                <td class="text-right">${currentPt}</td>
                <td class="${cls}">${status}</td>
            </tr>`;
        }).join('');

        const html = `
            <div class="d-flex justify-content-between align-items-center mb-2 small">
                <span class="text-muted">총 발급 <b class="text-dark">${fmt(total)}</b>건 · 활성 <b class="text-dark">${fmt(active)}</b>건</span>
                <span><span class="text-muted">합산 pt:</span> <b>${fmt(ptSum)}</b></span>
            </div>
            <table class="table table-bordered table-sm msix-grant-table" style="font-size:12px;width:100%;">
                <thead class="thead-light" style="text-align:center;">
                <tr>
                    <th>오더번호</th>
                    <th>작업일</th>
                    <th>발급일</th>
                    <th>차종</th>
                    <th>장비대금</th>
                    <th>일차</th>
                    <th>초기pt</th>
                    <th>현재pt</th>
                    <th>상태</th>
                </tr>
                </thead>
                <tbody>${trs || '<tr><td colspan="9" class="text-center text-muted py-3">발주 이력 없음</td></tr>'}</tbody>
            </table>
        `;
        $(`#${this.id}`).html(html);

        // DataTables — 페이징(20)만 활성. 정렬·검색·info 는 단순화 위해 비활성/축소.
        const $table = $(`#${this.id}`).find('table.msix-grant-table');
        if ($table.length > 0 && list.length > 0) {
            if (this._dt) this._dt.destroy();
            this._dt = new DataTable($table[0], {
                paging: true,
                pageLength: 20,
                lengthChange: false,
                searching: false,
                ordering: false,
                info: true,
                language: {
                    info: '_START_–_END_ / _TOTAL_건',
                    infoEmpty: '0건',
                    infoFiltered: '',
                    paginate: { first: '«', previous: '‹', next: '›', last: '»' },
                    zeroRecords: '데이터 없음',
                },
            });
        }
    }

    /**
     * 오더번호 → 오더 핸들 팝업(/adm/order/handle) 링크.
     * 관리자 수동지급 grant 는 ordernum 이 없다(0/null) → 링크를 걸지 않는다.
     * openOrderHandle 은 $j.F.Admin.Util 의 공용 메서드(main.js). 실리지 않은 화면에서도
     * 표가 깨지지 않게 $j.F.Admin.Util 존재를 확인하고 건다.
     */
    _orderLink(ordernum) {
        const num = parseInt(ordernum || 0);
        if (!num) return '—';
        if (!($j.F && $j.F.Admin && $j.F.Admin.Util)) return String(num);
        return `<a href="javascript:;" onclick="$j.F.Admin.Util.openOrderHandle(${num}, {name:'order_handle_${num}'})"
                   title="오더 핸들 열기">${num}</a>`;
    }

    _esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }
}
